import type { TransferRequest, ApprovalResult } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { post } from './request';

const SERVICE_PATH = 'rest/resource/transfers';

export default async function makeMoneyTransfer(transferRequest: TransferRequest): Promise<ApprovalResult> {
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}`, transferRequest);
}
